<template>
    <div>
        <div class="mb-3 p-3 rounded">    
            <div class="d-lg-flex align-items-center justify-content-between mb-4 gap-2">
                <div class="justify-content-start d-flex">
                    <h4><strong>Uso de la plataforma</strong></h4>
                </div>
                <div class="justify-content-end d-lg-flex d-md-flex d-sm-grid">
                    <a :href="urlstudentsdetail" class="text-decoration-underline">Ver detalles</a>
                </div>
            </div>
        </div>        
        <div>
            <apexchart height="300" type="line" :options="options" :series="series"></apexchart>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
export default {
    props: [
        "datacursos",
        "urlstudentsdetail"
    ],
    data(){
        return{
            options: {
                chart: {
                    id: 'vuechart-useplatform'
                },
                xaxis: {
                    categories: ["", "Semana 1", "Semana 2", "Semana 3", "Semana 4"]
                },
                /*yaxis: {
                    title: {
                        text: "Usuarios"
                    }
                },*/
                colors: ['#4000BC']
            },
            series: [{
                name: 'Cantidad de rutas',
                data: [0, 30, 40, 45, 50]
            }]
        }
    },
    mounted(){
        
    },
    watch: {
        datacursos(newVal, oldVal){
            if(typeof newVal != "undefined"){
                let datos = [];
                datos.push(0);
                newVal.forEach(element => {
                    datos.push(element);
                });
                this.series = [{
                    name: 'Cantidad de rutas',
                    data: datos
                }];
            }
        }
    },
    methods:{
        
    }
}
</script>

<style>
</style>